import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Link from 'shared/components/Link/Link';
import { withTranslate } from 'shared/hocs/withTranslate';
import Button from 'shared/components/AntdComponents/Button/Button';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { userVerifyMail, logistics } from 'shared/actions/user';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import { enqueueNotification } from 'shared/actions/notifications';
import s from './VerifyEmailModal.css';

const isMobile = __APP__ === 'mobile';

class VerifyEmailModal extends React.Component {
  static propTypes = {
    user: PropTypes.shape(),
    action: PropTypes.object, // eslint-disable-line
    enqueueNotif: PropTypes.func.isRequired,
    switchModal: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    //
    t: PropTypes.func.isRequired,
  };

  state = {
    verify: false,
    action: {},
    user: {},
  };

  confirmEmail = dat => {
    const { action, user, switchModal, enqueueNotif, t } = this.props;

    const phone = user.phones && user.phones.length && user.phones[0].number;

    action.userVerifyMail({ enqueueNotification });
    action.logistics({
      event: 'view',
      object_id: 0,
      object_type: 'advert',
      event_id: dat,
      user_id: user.id,
      email: user.email,
      phone,
      button: 'email verify',
    });
    switchModal();

    enqueueNotif(
      t(`На {email} отправлено сообщение для подтверждения почты`, { email: user.email }),
    );
  };

  render() {
    const {
      showModal,
      switchModal,
      user: { email, is_email_verified: isEmailVerified },
      t,
    } = this.props;
    const redirectUrl = `${t('locale') === 'uk' ? '/uk' : ''}/profile/`;

    if (isEmailVerified || !showModal) {
      return '';
    }

    return (
      <div className={s.root}>
        <ModalContainer
          modalCN={cx(s.modal, { [s.mobileModal]: isMobile })}
          onClose={switchModal}
          isOpen={showModal}
        >
          {!email &&
            <div className={s.mainBlock}>
              <div className={s.info}>
                {t('Для оформления подписки, нужно добавить электронную почту')}
              </div>
              <Link className={cx(s.btn)} to={redirectUrl}>
                {t('Добавить')}
              </Link>
            </div>}
          {email &&
            !isEmailVerified &&
            <div className={isMobile ? s.mobileRoot : s.desktopRoot}>
              <div className={s.mainBlock}>
                <span className={s.info}>
                  {t('Для оформления подписки, нужно подтвердить электронную почту')}
                </span>
                <Button
                  className={cx(s.btn)}
                  type="primary"
                  onClick={() => this.confirmEmail('Q9gqm1fCNuk2LOBKQ')}
                >
                  {t('Подтвердить')}
                </Button>
              </div>
            </div>}
          <span className={s.closeBtn} onClick={switchModal} />
        </ModalContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  enqueueNotification,
  user: user.user,
});

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators({ userVerifyMail, logistics }, dispatch),
  enqueueNotif: bindActionCreators(enqueueNotification, dispatch),
  dispatch,
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslate(VerifyEmailModal)),
);



// WEBPACK FOOTER //
// ./src/shared/components/VerifyEmailModal/VerifyEmailModal.js